export default "__VITE_ASSET__3QZOXwOb__"